import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-relocate",
  "use": "icon-relocate-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-relocate\">\n<path d=\"M150.3,40.2c-14-11.7-32.1-18.7-51.9-18.3C56.8,22.7,22.9,56.5,21.9,98c-1.1,44.1,34.3,80.1,78.1,80.1\n\tc28.5,0,53.5-15.3,67.1-38.1c3.1-5.2,0.8-11.9-4.8-14.3l-0.2-0.1c-4.6-1.9-9.8-0.1-12.4,4.1c-10.5,17.5-30,29-52.1,28.1\n\tc-29.9-1.2-54.2-25.4-55.5-55.2C40.5,69.5,67.1,42,100,42c13,0,25,4.3,34.7,11.5c3.4,2.6,3.8,7.6,0.8,10.6l-10.3,10.3\n\tc-1.6,1.6-0.5,4.3,1.8,4.3h40.3c2.8,0,5-2.2,5-5V33.4c0-2.2-2.7-3.3-4.3-1.8l-8.2,8.2C157.2,42.4,153.1,42.5,150.3,40.2z\" />\n<circle cx=\"100\" cy=\"100\" r=\"30.3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/relocate.svg
// module id = +Ie+
// module chunks = 3